import React from 'react';
const scattered = ['Una actividad sobre Jesús por acá.', 'Una ficha sobre los Mandamientos por allá.', 'Algo para explicar la Eucaristía.', 'Una propuesta para hablar del Espíritu Santo.', 'Una actividad diferente para que los chicos puedan pensar, escribir, conversar y llevar la fe a su vida.'];
export function PainSection() {
  return <section className="py-10 px-4 bg-white" data-id="element-107" data-mp="2yy61qmrxpd6n">
      <div className="max-w-3xl mx-auto text-center" data-id="element-108" data-mp="2l8m2hqxkay23">
        <h2 className="text-[20px] md:text-2xl font-black text-[#EE6A4D] mb-5 leading-tight" data-id="element-109" data-mp="2l71944mzhl5t">
          ¿CUÁNTAS VECES TUVISTE QUE PREPARAR CATEQUESIS Y TERMINASTE BUSCANDO
          ACTIVIDADES POR TODOS LADOS?
        </h2>

        <div className="space-y-1.5 mb-5" data-id="element-110" data-mp="2b8bpo7ffvsng">
          {scattered.map(item => <p key={item} className="text-base text-gray-700" data-id="element-111" data-mp="2g9sn1sypswza">
              {item}
            </p>)}
        </div>

        <div className="space-y-3 text-base text-gray-700" data-id="element-112" data-mp="22bkx4503ivxm">
          <p data-id="element-113" data-mp="277jeh8n0bdoj">
            Y finalmente terminás armando cada encuentro con recursos de
            distintos lugares.
          </p>
          <p data-id="element-114" data-mp="3rl7n04hj27yn">
            Porque dar Catequesis no es solamente explicar un tema. También
            necesitamos encontrar maneras de hacerlo comprensible, cercano y
            significativo para los chicos.
          </p>
          <p data-id="element-115" data-mp="gpz86hmypoa">
            Y entre clases, planificación y todas las demás responsabilidades...
            crear actividades desde cero lleva tiempo que muchas veces no
            tenemos.
          </p>
        </div>

        <p className="mt-5 text-lg md:text-xl font-black text-[#14356B]" data-id="element-116" data-mp="33xpxkflqjlyu">
          Preparar una buena Catequesis no debería significar empezar de cero
          cada semana.
        </p>
      </div>
    </section>;
}